import React from "react";
import { LockKeyhole, LockKeyholeOpen } from "lucide-react";
import ChantPopConfirm from "../../../../../CommonComponents/ChantTooltip/ChantPopConfirm";
import { useNavigate } from "react-router-dom";
import "./MemberActions.css";

const GroupLock = ({ groupLocked }) => {
  const navigate = useNavigate();
  const handleGroupLockedClick = () => {
    navigate(`/admin/members/packages/setup?scrollToPackageRequirement=true`);
  };

  return (
    <ChantPopConfirm
      title="Redirect to Package Setup?"
      onConfirm={handleGroupLockedClick}
      onCancel={() => {}}
      placement="bottom"
      okText="Yes"
      cancelText="No"
    >
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "8px",
          backgroundColor: "#f5f5f5",
          color: "#666666",
          borderRadius: "4px",
          padding: "6px 12px",
          fontWeight: 600,
          fontSize: "12px",
          letterSpacing: "0.5px",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
          textTransform: "uppercase",
          cursor: "pointer",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          {groupLocked ? (
            <LockKeyhole
              style={{
                fontSize: "20px",
                color: "var(--primary-background)",
              }}
            />
          ) : (
            <LockKeyholeOpen
              style={{
                fontSize: "20px",
                color: "var(--primary-background)",
              }}
            />
          )}
        </div>

        <div style={{ display: "flex", alignItems: "center" }}>
          <span className="group-lock-label">
            {groupLocked
              ? "MEMBER PACKAGE REQUIRED"
              : "MEMBER PACKAGE NOT REQUIRED"}
          </span>
        </div>
      </div>
    </ChantPopConfirm>
  );
};

export default GroupLock;
